import type { Dateable } from 'pkg/api/models/dateable';
import type { Record } from 'pkg/api/models/record';

export enum ConnectionStatus {
	Unknown = 'unknown',
	Pending = 'pending',
	Active = 'active',
	Deactivated = 'deactivated',
}

export enum ExternalServiceProvider {
	Wingfield = 'wingfield',
}

export interface ExternalService extends Record, Dateable {
	externalService: ExternalServiceProvider;
	externalData?: string;
	connectionStatus: ConnectionStatus;
}
